module.exports = __webpack_public_path__ + "img/theresACheaperOption.4a6843c5.svg";